/* Semana Eden (18-25/10/2026). Lo carga snippets/wk-eden-semana.liquid, que antes deja window.WKE con la fase y los ajustes.
   1. Cuenta atrás del domingo: rellena cada .wke-cuenta (hh:mm:ss hasta el lunes 19 a las 00:00 de Madrid).
   2. Tote de regalo: lee /products/<handle>.js, pone o quita la clase wke-tote en <html>, rellena [data-wke-tote-img]
      (atributo = ancho de la foto) y [data-wke-tote-titulo], y avisa con el evento 'wke:tote' en document.
   3. Cesta (19 al 25): si hay algún producto que no sea la tote, deja exactamente una tote marcada con la propiedad
      _wke_regalo; si solo queda la tote, o se han agotado, la quita. Escucha los cambios de la cesta que hace la web
      (fetch y XMLHttpRequest a /cart/add, change, update y clear) y vuelve a pintar el carrito lateral.
   4. Ayudas para el carrito y el regalo: WKE.suscribir(email, origen), WKE.aplicarCupon(), WKE.cuponAplicado(),
      WKE.abrirNewsletter(). */
(function () {
  var W = window.WKE;
  if (!W || !W.fase) return;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PROPIO = 'X-WKE';
  var html = document.documentElement;

  function api(ruta, cuerpo) {
    var cab = { 'Content-Type': 'application/json', Accept: 'application/json' };
    cab[PROPIO] = '1';
    return fetch(raiz + ruta, { method: cuerpo ? 'POST' : 'GET', headers: cab, credentials: 'same-origin', body: cuerpo ? JSON.stringify(cuerpo) : undefined })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  /* 1. Cuenta atrás */
  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function pintarCuenta() {
    var resta = Math.max(0, W.fases.f1 - W.ahora());
    var s = Math.floor(resta / 1000), txt = dos(Math.floor(s / 3600)) + ':' + dos(Math.floor(s / 60) % 60) + ':' + dos(s % 60);
    var els = document.querySelectorAll('.wke-cuenta');
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }
  if (W.fase === 'f0') { pintarCuenta(); setInterval(pintarCuenta, 1000); document.addEventListener('DOMContentLoaded', pintarCuenta); }

  /* 2. Tote de regalo */
  function conAncho(url, ancho) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + (ancho || 600);
  }
  function rellenarTote() {
    var t = W.toteDatos;
    if (!t) return;
    var imgs = document.querySelectorAll('[data-wke-tote-img]');
    for (var i = 0; i < imgs.length; i++) {
      var a = imgs[i].getAttribute('data-wke-tote-img') || 600;
      if (imgs[i].getAttribute('src') !== conAncho(t.foto, a)) imgs[i].setAttribute('src', conAncho(t.foto, a));
      imgs[i].removeAttribute('srcset');
    }
    var tits = document.querySelectorAll('[data-wke-tote-titulo]');
    for (var j = 0; j < tits.length; j++) if (tits[j].textContent !== t.titulo) tits[j].textContent = t.titulo;
  }
  W.toteListo = (W.toteHandle ? fetch(raiz + 'products/' + encodeURIComponent(W.toteHandle) + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p) return null;
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      return { id: v.id, disponible: !!p.available, precio: v.price, normal: v.compare_at_price, foto: p.featured_image, titulo: p.title };
    }) : Promise.resolve(null))
    .catch(function () { return null; })
    .then(function (t) {
      W.toteDatos = t;
      var hay = !!(t && t.disponible && !W.sinTote);
      html.classList.toggle('wke-tote', hay);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rellenarTote); else rellenarTote();
      document.dispatchEvent(new CustomEvent('wke:tote', { detail: { hay: hay, tote: t } }));
      return t;
    });
  /* El carrito lateral se vuelve a pintar entero: hay que rellenar de nuevo las fotos de la tote */
  var marco = 0;
  new MutationObserver(function () {
    if (!W.toteDatos || marco) return;
    marco = requestAnimationFrame(function () { marco = 0; rellenarTote(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* 3. Cesta */
  function secciones() { return document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble'; }
  function pintarSecciones(resp) {
    if (!resp || !resp.sections) return;
    var cd = document.querySelector('cart-drawer');
    var abierto = cd && cd.classList.contains('active');
    if (abierto && typeof cd.renderContents === 'function') {
      cd.renderContents(resp);
    } else {
      var lector = new DOMParser();
      Object.keys(resp.sections).forEach(function (id) {
        var nuevo = lector.parseFromString(resp.sections[id] || '', 'text/html');
        if (id === 'cart-drawer') {
          var dentro = nuevo.querySelector('#CartDrawer'), actual = document.querySelector('#CartDrawer');
          if (dentro && actual) actual.innerHTML = dentro.innerHTML;
        } else {
          var caja = document.getElementById(id), sec = nuevo.querySelector('.shopify-section');
          if (caja && sec) caja.innerHTML = sec.innerHTML;
        }
      });
    }
    if (cd && typeof resp.item_count === 'number') cd.classList.toggle('is-empty', resp.item_count === 0);
  }
  var ocupado = false, otraVez = false;
  function sincronizar() {
    if (!W.promo) return;
    if (ocupado) { otraVez = true; return; }
    ocupado = true;
    W.toteListo.then(function (t) {
      return api('cart.js').then(function (cart) {
        var deTote = cart.items.filter(function (i) { return t && i.variant_id === t.id; });
        var otras = cart.items.filter(function (i) { return !t || i.variant_id !== t.id; });
        var cant = deTote.reduce(function (s, i) { return s + i.quantity; }, 0);
        var quiere = t && t.disponible && !W.sinTote && otras.length > 0 ? 1 : 0;
        var bien = cant === quiere && (quiere === 0 || (deTote.length === 1 && deTote[0].properties && deTote[0].properties._wke_regalo));
        if (bien) return false;
        var paso = Promise.resolve();
        deTote.forEach(function (i) { paso = paso.then(function () { return api('cart/change.js', { id: i.key, quantity: 0 }); }); });
        return paso.then(function () {
          var extra = { sections: secciones(), sections_url: location.pathname };
          if (quiere) return api('cart/add.js', { items: [{ id: t.id, quantity: 1, properties: { _wke_regalo: '1' } }], sections: extra.sections, sections_url: extra.sections_url })
            .then(function (r) { return api('cart/update.js', { updates: {}, sections: extra.sections, sections_url: extra.sections_url }).catch(function () { return r; }); });
          return api('cart/update.js', { updates: {}, sections: extra.sections, sections_url: extra.sections_url });
        }).then(function (resp) {
          pintarSecciones(resp);
          document.dispatchEvent(new CustomEvent('wke:cesta', { detail: resp }));
          return true;
        });
      });
    }).then(function (cambio) {
      /* En la página /cart no hay carrito lateral: se recarga una vez para que salga la tote (o deje de salir) */
      if (cambio && /\/cart\/?$/.test(location.pathname)) location.reload();
    }).catch(function () {}).then(function () {
      ocupado = false;
      if (otraVez) { otraVez = false; sincronizar(); }
    });
  }
  W.sincronizar = sincronizar;
  var RUTA_CESTA = /\/cart\/(add|change|update|clear)/;
  var temporizador;
  function trasCambio() { clearTimeout(temporizador); temporizador = setTimeout(sincronizar, 350); }
  if (W.promo) {
    var fetchOriginal = window.fetch;
    window.fetch = function (entrada, opciones) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var cab = opciones && opciones.headers, propio = false;
      if (cab) propio = typeof cab.get === 'function' ? !!cab.get(PROPIO) : !!cab[PROPIO];
      var p = fetchOriginal.apply(this, arguments);
      if (!propio && RUTA_CESTA.test(url)) p.then(trasCambio, function () {});
      return p;
    };
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      if (RUTA_CESTA.test(String(url))) this.addEventListener('load', trasCambio);
      return abrirXhr.apply(this, arguments);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincronizar); else sincronizar();
    window.addEventListener('pageshow', function (e) { if (e.persisted) sincronizar(); });
  }

  /* 4. Ayudas */
  W.suscribir = function (email, origen) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + W.klaviyo.empresa, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-02-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: origen || 'Semana Eden',
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: W.klaviyo.lista } } } } })
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return true; });
  };
  W.cuponAplicado = function () { try { return localStorage.getItem('wke_cupon') === W.cupon && !!W.cupon; } catch (e) { return false; } };
  W.aplicarCupon = function () {
    if (!W.cupon) return Promise.reject(new Error('sin cupón'));
    var cab = {}; cab[PROPIO] = '1';
    return fetch(raiz + 'discount/' + encodeURIComponent(W.cupon), { credentials: 'same-origin', headers: cab })
      .then(function () { try { localStorage.setItem('wke_cupon', W.cupon); } catch (e) {} return true; });
  };
  W.abrirNewsletter = function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', W.klaviyo.formulario]);
  };
})();
